import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.function.name.js";
import React, { useMemo, useContext } from 'react';
import { Form } from '@applyboard/ui-components';
import { LoadingOverlay } from "../../../../ab-common-legacy/LoadingOverlay";
import MarketsContext from "../../../CEF/Providers/Markets/MarketsContext";
import { Content } from "./Content";
import { useOnboardingFormControllerContext } from "../../../controller/OnboardingFormController";
import { useMarketPreferences, useEditMarketPreferences, useDeleteMarketPreferences } from "../../../../data/marketPreferences";
import { getAcceptableCountries, storeCountries, deleteStoredCountries } from "../../storage/Countries/localStorage";
import { useAppContext } from "../../../CEF/Providers";
import { FormStateContext } from "../../../FormStateProvider";
export var CountriesPage = function CountriesPage() {
  var _useContext = useContext(MarketsContext),
    marketsData = _useContext.data,
    isLoading = _useContext.isLoading;
  var _useContext2 = useContext(FormStateContext),
    onShowError = _useContext2.onShowError;
  var _useOnboardingFormCon = useOnboardingFormControllerContext(),
    handlePassed = _useOnboardingFormCon.handlePassed,
    handleSkipped = _useOnboardingFormCon.handleSkipped,
    handleError = _useOnboardingFormCon.handleError,
    setCountries = _useOnboardingFormCon.setCountries;
  var _useAppContext = useAppContext(),
    userId = _useAppContext.userId;
  userId = userId ? userId.toString() : null;
  var _useMarketPreferences = useMarketPreferences(userId, {
      enabled: Boolean(userId)
    }),
    marketPreferences = _useMarketPreferences.marketPreferences,
    isLoadingMarketPreferences = _useMarketPreferences.isLoadingMarketPreferences;
  var _useEditMarketPrefere = useEditMarketPreferences(userId),
    editMarketPreferences = _useEditMarketPrefere.editMarketPreferences;
  var _useDeleteMarketPrefe = useDeleteMarketPreferences(userId),
    deleteMarketPreferences = _useDeleteMarketPrefe.deleteMarketPreferences;
  var options = useMemo(function () {
    if (!isLoading && marketsData.length > 0) {
      var marketOptions = marketsData.map(function (data) {
        return {
          label: data.commonName,
          name: data.id
        };
      });
      return marketOptions;
    }
    return [];
  }, [isLoading, marketsData]);
  if (options.length === 0 || isLoadingMarketPreferences && userId) {
    return /*#__PURE__*/React.createElement(LoadingOverlay, {
      "aria-label": "Loading"
    });
  }
  var signedInSubmit = function signedInSubmit(selectedMarkets) {
    var data = {
      values: selectedMarkets,
      type: 'market'
    };
    editMarketPreferences(data, {
      onSuccess: function onSuccess() {
        var selectedMarketNames = selectedMarkets.map(function (market) {
          var _options$find$label, _options$find;
          return (_options$find$label = (_options$find = options.find(function (option) {
            return option.name === market;
          })) === null || _options$find === void 0 ? void 0 : _options$find.label) !== null && _options$find$label !== void 0 ? _options$find$label : market;
        });
        handlePassed({
          values: selectedMarketNames
        });
      },
      onError: function onError() {
        onShowError();
        handleError();
      }
    });
  };
  var unsignedInSubmit = function unsignedInSubmit(selectedMarkets) {
    storeCountries(selectedMarkets);
  };
  var skipSubmit = function skipSubmit() {
    if (userId) {
      deleteMarketPreferences(undefined, {
        onSuccess: function onSuccess() {
          handleSkipped();
        },
        onError: function onError() {
          onShowError();
          handleError();
        }
      });
    } else {
      deleteStoredCountries();
      handleSkipped();
    }
  };
  var countriesSubmit = function countriesSubmit(data) {
    var selectedMarkets = data.countries;
    setCountries(selectedMarkets);
    if (userId) {
      signedInSubmit(selectedMarkets);
    } else {
      unsignedInSubmit(selectedMarkets);
      var selectedMarketNames = selectedMarkets.map(function (market) {
        var _options$find$label2, _options$find2;
        return (_options$find$label2 = (_options$find2 = options.find(function (option) {
          return option.name === market;
        })) === null || _options$find2 === void 0 ? void 0 : _options$find2.label) !== null && _options$find$label2 !== void 0 ? _options$find$label2 : market;
      });
      handlePassed({
        values: selectedMarketNames
      });
    }
  };
  var defaultValues = {
    countries: userId ? marketPreferences : getAcceptableCountries()
  };
  return /*#__PURE__*/React.createElement(Form, {
    onSubmit: function onSubmit(data) {
      return countriesSubmit(data);
    },
    defaultValues: defaultValues,
    onSubmitError: handleError
  }, /*#__PURE__*/React.createElement(Content, {
    options: options,
    noBackButton: true,
    skipSubmit: skipSubmit
  }));
};